import { useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { smoothScrollToId } from "../utils/scrollToHash";
import { trackEvent } from "../utils/analytics";

/**
 * Navigate to an in-page anchor. If already on Home, smooth-scrolls.
 * From another route, routes to Home first then scrolls once mounted.
 */
const useAnchorNav = () => {
  const navigate = useNavigate();
  const location = useLocation();

  return useCallback(
    (id, { onDone } = {}) => {
      trackEvent("nav_click", { target_section: id });

      const scroll = () => {
        if (smoothScrollToId(id)) {
          window.history.replaceState(null, "", `#${id}`);
        }
      };

      if (location.pathname === "/") {
        scroll();
      } else {
        navigate("/");
        // Let Home mount before scrolling to the target section.
        window.requestAnimationFrame(() => window.setTimeout(scroll, 60));
      }

      if (onDone) {
        onDone();
      }
    },
    [location.pathname, navigate]
  );
};

export default useAnchorNav;
